Vue.use(Vuex)

function _scroll(state, n) {
	state.scroll = n
}

function _showIntro(state, bool) {
	state.loopHelper.showIntro = bool
}

function _showOutro(state, bool) {
	state.loopHelper.showOutro = bool
}

function _dismissOutro(state, bool) {
	state.loopHelper.dismissOutro = bool
}

function _fixOutro(state, bool) {
	state.loopHelper.fixOutro = bool
}

function _isIntro(state, bool) {
	state.loopHelper.isIntro = bool
}

function _introAnimation(state, bool) {
	state.loopHelper.introAnimation = bool
}

function _updateLoadingHeader(state, obj) {
	Object.assign(state.loadingOptions, obj)
}

function _progressBarEnabled(state, bool) {
	state.progressBarEnabled = bool
}

function _showUpArrow(state, bool) {
	if (!state.loopHelper.readyToShowUpArrow && bool == true) {
		console.log('Not ready to show up arrow. First store.commit("readyToShowUpArrow", true)')
		return
	}
	state.loopHelper.showUpArrow = bool
}

function _readyToShowUpArrow(state, bool) {
	state.loopHelper.readyToShowUpArrow = bool
}

function _pushToSections(state, item) {
	if (item['multi-line_title'] != '' && item['multi-line_title']) {
		item.title.rendered = item['multi-line_title']
	} else if (item.name) {
		// Populate tags with fields that match posts
		item.title = {}
		item.content = {}
		item.title.rendered = item.name
		item.content.rendered = item.description
	}
	console.log('Load new section: ', item)
	state.sections.push(item)
	Vue.nextTick(() => {
		store.commit('progressBarEnabled', true)
	})
}

function _clearSections(state) {
	state.sections = []
}

function _clearPreviousSections(state) {
	state.sections.splice(0, state.sections.length -1)
}

function _loadMenu(state, items) {

	let menuItems = []

	for (let i = 0; i < items.length; i++) {
		menuItems[i] = Object.assign({}, items[i], {
			isCurrent: false
		})
	}

	state.menu = menuItems

	this.commit('updateCurrentMenuItem', {
		id: wp.id,
		title: wp.title
	})

}

function _updateCurrentMenuItem(state, obj) {

	for (let item of state.menu) {
		if (item.ID == obj.id) {
			item.isCurrent = true
		} else {
			item.isCurrent = false
		}
	}

	state.currentMenuItem.title = obj.title

}

function _isMobile(state, bool) {
	state.mobile = bool
}

function _isScrolling(state, bool) {
	state.isScrolling = bool
}

function _introPadding(state, bool) {
	state.loopHelper.introPadding = bool
}

function _pixelHasFadeOut(state, bool) {
	state.loopHelper.pixelHasFadeOut = bool
}

const store = new Vuex.Store({
  state: {
    scroll: 0,
	sections: [],
	menu: [],
	mobile: false,
	isScrolling: false,
	loadingOptions: {
		color: '#000',
		cursor: 'internal',
		show: false
	},
	currentMenuItem: {
		isCurrent: false,
		title: wp.title || ''
	},
	loopHelper: {
		scrollTop: 0,
		isHome: wp.isHome,
		showIntro: wp.isHome ? true : false,
		introPadding: false,
		showOutro: wp.isHome ? false : true,
		dismissOutro: false,
		hideReplacementOutro: wp.isHome ? true : false,
		progressBarEnabled: wp.isHome ? false : true,
		isIntro: wp.isHome ? true : false,
		showUpArrow: false,
		fixOutro: false,
		introAnimation: wp.isHome ? false : true,
		pixelHasFadeOut: wp.isHome ? false : true
	}
  },
  mutations: {
    scroll: _scroll,
	showIntro: _showIntro,
	showOutro: _showOutro,
	showUpArrow: _showUpArrow,
	readyToShowUpArrow: _readyToShowUpArrow,
	dismissOutro: _dismissOutro,
	fixOutro: _fixOutro,
	isIntro: _isIntro,
	updateLoadingHeader: _updateLoadingHeader,
	progressBarEnabled: _progressBarEnabled,
	introAnimation: _introAnimation,
	pushToSections: _pushToSections,
	clearSections: _clearSections,
	clearPreviousSections: _clearPreviousSections,
	loadMenu: _loadMenu,
	updateCurrentMenuItem: _updateCurrentMenuItem,
	isMobile: _isMobile,
	isScrolling: _isScrolling,
	introPadding: _introPadding,
	pixelHasFadeOut: _pixelHasFadeOut
  }
})

export default store
